if (!customElements.get('cart-discounts')) {
  class CartDiscounts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.discounts();
    }

    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }
      ];
    }

    getSectionInnerHTML(html, selector) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const target = parsed.querySelector(selector);
      return target ? target.innerHTML : html;
    }

    discounts() {
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.cart-discounts--button');
        const removeButton = event.target.closest('.cart-discounts--remove');

        if (button) {
          event.preventDefault();
          this.updateDiscount(button);
        }

        if (removeButton) {
          event.preventDefault();
          this.removeDiscount(removeButton);
        }
      });
    }

    updateDiscount(button) {
      const discountInput = this.querySelector('.cart-discounts--input');
      if (!discountInput) return;

      const discountCodeValue = discountInput.value.trim();

      if (!discountCodeValue) {
        return;
      }

      const existingDiscounts = this.existingDiscounts();

      if (!existingDiscounts.includes(discountCodeValue)) {
        existingDiscounts.push(discountCodeValue);
      }

      button.classList.add('loading');
      this.renderDiscounts(existingDiscounts, discountCodeValue);
    }

    removeDiscount(removeButton) {
      const row = removeButton.closest('.cart-discounts--row');
      if (!row) return;

      const pill = row.querySelector('.cart-discounts--name');
      if (!pill) return;

      const discountCode = pill.textContent.trim();
      const existingDiscounts = this.existingDiscounts();
      const index = existingDiscounts.indexOf(discountCode);

      if (index === -1) return;

      existingDiscounts.splice(index, 1);
      this.renderDiscounts(existingDiscounts);
    }

    existingDiscounts() {
      return Array.from(this.querySelectorAll('.cart-discounts--name'))
        .map((pill) => pill.textContent.trim())
        .filter(Boolean);
    }

    renderDiscounts(existingDiscounts, discountCodeValue) {
      const body = JSON.stringify({
        discount: existingDiscounts.join(','),
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      const errorEl = this.querySelector('.cart-discounts--error');
      if (errorEl) errorEl.setAttribute('hidden', '');

      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body
      })
        .then((response) => response.json())
        .then((parsedState) => {
          this.getSectionsToRender().forEach((section) => {
            const wrapper = document.getElementById(section.id);
            if (!wrapper || !parsedState.sections || !parsedState.sections[section.section]) return;

            const elementToReplace = wrapper.querySelector(section.selector) || wrapper;
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });

          document.querySelectorAll('.cart-discounts--button').forEach((btn) => {
            btn.classList.remove('loading');
          });

          document.querySelectorAll('.cart-discounts--title').forEach((summary) => {
            const details = summary.closest('details');
            if (details) details.setAttribute('open', '');
          });

          if (
            discountCodeValue &&
            parsedState.discount_codes &&
            parsedState.discount_codes.find((discount) => {
              return discount.code === discountCodeValue && discount.applicable === false;
            })
          ) {
            setTimeout(() => {
              const err = document.querySelector('.cart-discounts--error');
              if (err) err.removeAttribute('hidden');
            }, 300);
          }
        })
        .catch(() => {
          const err = document.querySelector('.cart-discounts--error');
          if (err) err.removeAttribute('hidden');
        });
    }
  }

  customElements.define('cart-discounts', CartDiscounts);
}